import AGButton from "../../../components/Button";
import AGModalComfirmModal from "../../../components/ComfirmModal";

export interface DeleteConfirmModalProps {
	visible: boolean;
	toggleModal: () => void;
	deleteService: () => void;
	zIndex?: number;
	tab?: string;
}
const DeleteConfirmModal = ({
	visible,
	toggleModal,
	deleteService,
	zIndex,
	tab
}: DeleteConfirmModalProps) => {

	const handleTextByTab = (tab: string) => {
		switch (tab) {
			case "service":
				return "service";
			case "product":
				return "product";
			case "secondment":
				return "secondment";
			default:
				return "";
		}
	};
	
	return (
		<AGModalComfirmModal
			toggleModal={() => {
				toggleModal();
			}}
			title={tab === "service" ? "Delete Service" :
					tab === "product" ? "Delete Product" :
						tab === "secondment" ? "Delete Secondment" : "" }
			footer={<> <AGButton
				type="Primary"
				onClick={() => {
					deleteService();
				}}>
				Delete
			</AGButton>
				<AGButton
					type="Secondary"
					onClick={() => {
						toggleModal();
					}}
				>
					Cancel
				</AGButton></>}
			visible={visible}
			setHeight={190}
			zIndex={zIndex}
		>
			<div style={{ padding: 20 }}>
			Are you sure to delete the selected expertise {handleTextByTab(tab ?? "")}?
			</div>
		</AGModalComfirmModal>

	);
};

export default DeleteConfirmModal;
